export default class TwoProgrammes {
	constructor(elm) {
        this.elm = elm;

		this.boundMouseOverListener = this.mouseOverListener.bind(this);
        this.elm.addEventListener('mouseover', this.boundMouseOverListener);

        this.cards = this.elm.querySelectorAll('.c-card-programme');
        this.cards.forEach((card, index) => {
            if(index>0) {
                return;
            }
            card.classList.add('c-card-programme--active');
        });

	}

    mouseOverListener(e) {
        if (e.target.closest('.c-card-programme')) {
			this.cards.forEach((card) => {
				card.classList.remove('c-card-programme--active');
			});
			e.target.closest('.c-card-programme').classList.add('c-card-programme--active');
		}
    }

	destroy() {
		this.elm.removeEventListener('mouseover', this.boundMouseOverListener);
	}
}
